import React from "react";
import AonPannel from "../../components/core/AonPannel";
import { observer } from 'mobx-react';
import { useMarketDetailsStore } from "../../store";
export var MarketAddtionalInfo = observer(function () {
    var marketDetailsStore = useMarketDetailsStore();
    var MarketAddtionalInfoBody = observer(function () {
        return React.createElement("div", { style: { fontWeight: "bold", fontSize: "18px" } }, marketDetailsStore.AdditionalInfo);
    });
    return marketDetailsStore.AdditionalInfo ? React.createElement(AonPannel, { headerTitle: "Important Info", Body: React.createElement(MarketAddtionalInfoBody, null) }) : React.createElement(React.Fragment, null);
});
